import { Injectable } from '@angular/core';
import { CustomPageConfigService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class OttoOlsenCustomPageConfigService extends CustomPageConfigService {

}
